import React, { Component } from 'react';
import { connect } from 'react-redux';
import marked from 'marked';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import faGlobe from '@fortawesome/fontawesome-free-solid/faGlobe';
import faFacebook from '@fortawesome/fontawesome-free-brands/faFacebook';
import faYoutube from '@fortawesome/fontawesome-free-brands/faYoutube';
import faTimes from '@fortawesome/fontawesome-free-solid/faTimes';
// import faEnvelope from '@fortawesome/fontawesome-free-solid/faEnvelope';
// import faPhone from '@fortawesome/fontawesome-free-solid/faPhone';
// import { toggleModal, getItemById } from '../lib/util';
// import melchersLogo from '../images/Melchers-Logo-large.png';
import { apiUrl } from '../config/config';
import './Footer.css';
import { toggleModal } from '../lib/util';

class Footer extends Component {
    constructor(props) {
    super(props);
    this.state = {
      modalActive: false,
    };
    this.toggleModal = this.toggleModal.bind(this);
  }

  toggleModal() {
    this.setState({
      modalActive: !this.state.modalActive,
    }, () => {
      toggleModal(this.state.modalActive);
    });
  }

  render () {
    const { pages, contacts } = this.props;
    const engInfo = pages.find(page => page.name === 'eng_info');
    const footer_facebook = pages.find(page => page.name === 'footer_facebook');
    const footer_youtube = pages.find(page => page.name === 'footer_youtube');
    const footer_copyright = pages.find(page => page.name === 'footer_copyright');
    let contact1 = null; 
    let contact2 = null;
    if(contacts){
        contact1 = contacts[0];
        contact2 = contacts[1];
    }

    return (
      <footer className="footer is-stihl">
        <div className="container is-fluid">
            <div className="inner-container">
                <div className="columns">
                    <div className="column company-info">
                        <img src={`${apiUrl}/uploads/3da0b9acf8d94c32be53b011d0a92db7.png`} alt="Melchers group"></img>
                        <p>德商美最時貿易股份有限公司</p>
                        <p>Melchers Trading GmbH (Taiwan Branch)</p>
                    </div>
                    <div className="column is-half footer-contact">
                        <div className="contact-title">
                            <span>聯絡我們</span>
                        </div>
                        <div className="contact-locations columns">
                            {contact1 && 
                                <div className="column is-first">
                                    <p className="location-title">{`${contact1.title} ${contact1.eng_title}`}</p>
                                    <p className="location-address">{contact1.address}</p>
                                    <p className="phone"><a href={`tel:${contact1.phone}`}>{contact1.phone}</a></p> 
                                </div>
                            }
                            {contact2 && 
                                <div className="column is-second">
                                    <p className="location-title">{`${contact2.title} ${contact2.eng_title}`}</p>
                                    <p className="location-address">{contact2.address}</p>
                                    <p className="phone"><a href={`tel:${contact2.phone}`}>{contact2.phone}</a></p> 
                                </div>
                            }
                        </div>
                    </div>
                    <div className="column social is-narrow">
                        <div className="social-title">
                            <span>追蹤我們</span>
                        </div>
                        <div className="social-icons">
                            {footer_facebook && 
                                <a href={footer_facebook.content} target="_blank" rel="noopener noreferrer">
                                    <FontAwesomeIcon className="social-icon" icon={faFacebook} size="2x"/>
                                </a>
                            }
                            {footer_youtube && 
                                <a href={footer_youtube.content} target="_blank" rel="noopener noreferrer">
                                    <FontAwesomeIcon className="social-icon" icon={faYoutube} size="2x"/>
                                </a>
                            }
                        </div>
                        {/*<div className="social-line">
                            <a href="https://line.me/R/ti/p/%40fxi2505e"><img height="36" border="0" alt="加入好友" src="https://scdn.line-apps.com/n/line_add_friends/btn/zh-Hant.png"/></a>
                        </div>*/}
                    </div>
                </div>

                <div className="columns has-border-top">
                    <div className="column">
                        <div className="columns copy-right">
                            {/*<div className="column is-narrow logo-bw"/>*/}
                            {footer_copyright && <div className="column is-narrow logo-str">{footer_copyright.content}</div>}
                        </div>
                    </div>
                    <div className="column eng-info">
                        <div className="hover-wrapper" onClick={this.toggleModal}>
                            <FontAwesomeIcon icon={faGlobe}/>
                            <span>English info</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className={this.state.modalActive ? 'modal modal-eng-info is-active' : 'modal modal-eng-info'}>
          <div
            className="modal-background"
            role="button"
            tabIndex={0}
            onClick={this.toggleModal}
            onKeyUp={this.toggleModal}
          />
          <div
            className="modal-content"
            role="button"
            tabIndex={0}
            onClick={(e) => {
              e.stopPropagation();
            }}
            onKeyUp={(e) => {
              e.stopPropagation();
            }}
          >
            <div className="card">
              <button className="card-close" aria-label="close" onClick={this.toggleModal}>
                <FontAwesomeIcon icon={faTimes} />
              </button>
                {/*
                <div className="card-content">
                    <div className="card-content-header">
                        <h1>Dear Customer</h1>
                    </div>
                    <div className="card-content-body">
                        <p>Thank you for your interest. For detailed information about Stihl products in English,</p>
                        <p>
                            <span>Please visit </span>
                            <a>https://www.stihl.com</a>
                            <span>. For further information about Stihl in Taiwan, kindly contact:</span>
                        </p>
                    </div>
                    <div className="card-content-footer">
                        <h2>Mr. David Sun</h2>
                        <div>
                            <FontAwesomeIcon icon={faEnvelope} />
                            <span>David.sun@melchers.com.tw</span>
                        </div>
                        <div>
                            <FontAwesomeIcon icon={faPhone} />
                            <span>+886-2-25513264</span>
                        </div>
                    </div>
                </div>
                */}

                {engInfo && 
                    <div
                      className="card-content"
                      dangerouslySetInnerHTML={{ __html: marked(engInfo.content) }}
                    />
                }
            </div>
          </div>
        </div>
      </footer>
    )
  }
}

const mapStateToProps = state => ({
  pages: state.pages,
  contacts: state.contacts,
});

export default connect(mapStateToProps)(Footer);



// WEBPACK FOOTER //
// ./src/components/Footer.js